import React from "react";
import "../css/returns.scss";

function Returns() {
  return (
    <main className="_main_guvbo_9">
      <section
        className="ds-container p-m tablet:p-m flex flex-col justify-start tablet:justify-start"
        data-section-type="section:text"
      >
        <div className="flex justify-start tablet:justify-start">
          <div className="flex flex-col items-start text-left">
            <div className="relative flex flex-col gap-2">
              <p className="type-title-l tablet:type-title-l">RETURNS</p>
              <p className="type-title-m tablet:type-title-m">
                What is the return portal?
              </p>
              <p className="type-body-s tablet:type-body-s">
                By registering your return online, you can track it through the
                return portal.
                <br />
                <br />
                You will also receive updates on your parcel’s journey back to
                our warehouse and be notified when your return arrives for
                processing.
                <br />
                <br />
                If you need a new label to return your items, you can easily
                create one yourself.
              </p>

              <p className="type-title-m tablet:type-title-m">Return period</p>
              <p className="type-body-s tablet:type-body-s">
                For all online orders, you have 100 days from the date you
                receive your order to return any items.
                <br />
                <br />
                Please note that returns can only be registered through the
                return portal for orders purchased online.
              </p>

              <p className="type-title-m tablet:type-title-m">Return fee</p>
              <p className="type-body-s tablet:type-body-s">
                You only need to pay one return fee for each order you return,
                regardless of how many labels you create online or how many
                parcels your order is shipped in.
                <br />
                <br />
                If you return the goods using our return label, you will be
                charged a return fee, which will be deducted from your refund.
                We charge the costs of returning per order returned to us. You
                are responsible for the return of the item(s).
              </p>

              <p className="type-title-m tablet:type-title-m">How to log in</p>
              <p className="type-body-s tablet:type-body-s">
                You can access the returns portal without an account; simply
                provide your order number along with the postcode connected to
                the delivery address or the email address linked to the order.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Returns;
